'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _components = require('components');

var _support = require('helpers/support');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { getPhone } from 'helpers/lib';
// import ReactGA from 'react-ga';
var LookmeServiceAtHome = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    SERVICE_OF_HOME_SERVICE: state.shops.SERVICE_OF_HOME_SERVICE,
    submit: state.shops.submit,
    shop: state.shops.shop,
    voucherFilters: state.voucher.voucherFilters,
    voucherFilterChosen: state.voucher.voucherFilterChosen
  };
}, {
  beforeExchangeReward: voucherActions.beforeExchangeReward,
  exchangeReward: voucherActions.exchangeReward,
  getMyReward: voucherActions.getMyReward,
  resetBooking: bookingActions.resetBooking,
  setDefaultBooking: bookingActions.setDefaultBooking,
  changeShopBeforeBooking: bookingActions.changeShopBeforeBooking,
  loadServiceOfHomeService: shopActions.loadServiceOfHomeService,
  changeService: shopActions.changeService,
  getShopData: shopActions.getShopData,
  resetShopDetail: shopActions.resetShopDetail,
  setPathName: _setup.setPathName,
  changeVoucherFilter: voucherActions.changeVoucherFilter,
  showDownloadAppPopup: setupActions.showDownloadAppPopup
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LookmeServiceAtHome, _Component);

  function LookmeServiceAtHome(props) {
    (0, _classCallCheck3.default)(this, LookmeServiceAtHome);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LookmeServiceAtHome.__proto__ || (0, _getPrototypeOf2.default)(LookmeServiceAtHome)).call(this, props));

    _this.renderAllService = _this.renderAllService.bind(_this);
    _this.state = {
      showErr: false,
      contentErr: {
        title: { text: 'Lỗi', type: 'error' },
        message: []
      },
      showFlow: false,
      contentFlow: {
        title: { text: 'Thông Báo', type: 'success' },
        message: []
      },
      showOption: false,
      service: null
    };
    _this.toBooking = _this.toBooking.bind(_this);
    _this.toBookingWithOption = _this.toBookingWithOption.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(LookmeServiceAtHome, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (_support.Helper.isDev()) {
        this.props.getShopData('lookme-4-freelance');
        this.props.loadServiceOfHomeService('5f4caf9e8965d0001f7081c7');
      } else {
        this.props.getShopData('lookme-dv-tai-nha');
        this.props.loadServiceOfHomeService('5f34e25fd40e73001f1d2226');
      }
      if (this.props.route.path === 'dich-vu-tai-nha') {
        this.props.changeVoucherFilter('Dịch vụ tại nhà');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.resetShopDetail();
    }
  }, {
    key: 'onChangeService',
    value: function onChangeService(e, ser) {
      // console.log('onchange service', ser);
      e.stopPropagation();
      var _id = ser._id,
          name = ser.name,
          price = ser.price;

      var service = { _id: _id, service: _id, number: 1, name: name, price: price };
      console.log('onChangeService', ser);
      if (ser && ser.groupedOptions && ser.groupedOptions.length) {
        this.showOption();
        this.setState({ service: ser });
      }
      this.props.changeService(service);
    }
  }, {
    key: 'renderAllService',
    value: function renderAllService(service, i) {
      var _this2 = this;

      var bookingServices = this.props.submit.bookingServices;

      return _react2.default.createElement(_components.ServiceItemSmall, {
        key: 'serviceItem_' + i,
        active: bookingServices[0] && bookingServices[0]._id === service._id,
        item: service,
        onPress: function onPress(e) {
          return _this2.onChangeService(e, service);
        }
      });
    }
  }, {
    key: 'toBookingWithOption',
    value: function toBookingWithOption(_ref) {
      var service = _ref.service,
          selectedOptions = _ref.selectedOptions;

      this.props.showDownloadAppPopup();
      // const { _id, name, price } = service;
      // const ser = { _id, service: _id, number: 1, name, price, selectedOptions };
      // const bookingServices = [];
      // bookingServices.push(ser);
      // const { shop, user } = this.props;
      // const submit = { bookingServices };
      // shop.shopType = 'freelance';
      // this.props.resetBooking();
      // if (user) {
      //   this.props.changeShopBeforeBooking(shop, user);
      // } else {
      //   this.props.changeShopBeforeBooking(shop);
      // }
      // this.props.setDefaultBooking(submit);
      // this.props.history.push(`/dat-lich`);
      // console.log('toBookingWithOption', service, selectedOptions, newOptions);
    }
  }, {
    key: 'toBooking',
    value: function toBooking() {
      this.props.showDownloadAppPopup();
      // const { shop, submit, user } = this.props;
      // shop.shopType = 'freelance';
      // if (submit.bookingServices && submit.bookingServices.length) {
      //   this.props.resetBooking();
      //   if (user) {
      //     this.props.changeShopBeforeBooking(shop, user);
      //   } else {
      //     this.props.changeShopBeforeBooking(shop);
      //   }
      //   this.props.setDefaultBooking(submit);
      //   this.props.history.push(`/dat-lich`);
      // } else {
      //   alert('bạn cần chọn dịch vụ trước');
      // }
    }
  }, {
    key: 'hideOption',
    value: function hideOption() {
      this.setState({ showOption: false });
    }
  }, {
    key: 'showOption',
    value: function showOption() {
      this.setState({ showOption: true });
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var bookingServices = this.props.submit.bookingServices;

      var styles = require('./LookmeServiceAtHome.scss');
      var service = bookingServices[0];
      return _react2.default.createElement(
        'div',
        { className: styles.groupBtn },
        _react2.default.createElement(
          'div',
          { className: styles.totalCost },
          _react2.default.createElement(
            'label',
            null,
            'T\u1ED5ng ti\u1EC1n'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.groupPrice },
            !!service && _react2.default.createElement(
              'p',
              null,
              _support.Helper.formatMoney(service.price)
            ),
            !!service && _react2.default.createElement(
              'span',
              null,
              service.name
            )
          )
        ),
        _react2.default.createElement(
          'button',
          { onClick: this.toBooking },
          '\u0110\u1EB6T L\u1ECACH'
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          homeOff = _props.homeOff,
          dataService = _props.SERVICE_OF_HOME_SERVICE.data,
          voucherFilterChosen = _props.voucherFilterChosen,
          voucherFilters = _props.voucherFilters,
          history = _props.history,
          route = _props.route;
      var _state = this.state,
          showErr = _state.showErr,
          contentErr = _state.contentErr,
          showFlow = _state.showFlow,
          contentFlow = _state.contentFlow,
          showOption = _state.showOption,
          service = _state.service;

      var styles = require('./LookmeServiceAtHome.scss');
      var hideCategory = true;
      return _react2.default.createElement(
        'div',
        { className: styles.allReward },
        !hideCategory && _react2.default.createElement(
          'div',
          { className: styles.slider },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-cham-soc-da-massage' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.massageIcon }),
              'Ch\u0103m S\xF3c Da/Massage'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-lam-toc-mong' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.hairIcon }),
              'L\xE0m T\xF3c/M\xF3ng'
            )
          ),
          !homeOff && _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-dich-vu-tai-nha' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.homeServiceIcon }),
              'L\xE0m \u0110\u1EB9p T\u1EA1i Nh\xE0'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-tham-my-vien' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.cosmeticIcon }),
              'Th\u1EA9m M\u1EF9 Vi\u1EC7n'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-phong-kham' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.clinicIcon }),
              'Ph\xF2ng Kh\xE1m'
            )
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/uu-dai-the-duc-the-thao' },
            _react2.default.createElement(
              'div',
              { className: styles.catItem },
              _react2.default.createElement('div', { className: styles.fitnessIcon }),
              'Th\u1EC3 D\u1EE5c Th\u1EC3 Thao'
            )
          )
        ),
        _react2.default.createElement(_components.VoucherFilterBar, {
          voucherFilterChosen: voucherFilterChosen,
          voucherFilters: voucherFilters,
          history: history,
          route: route,
          changeVoucherFilter: this.props.changeVoucherFilter
        }),
        _react2.default.createElement(
          'div',
          { className: styles.listVoucher },
          !!(dataService && dataService.length) ? dataService.map(function (ser, i) {
            return _this3.renderAllService(ser, i);
          }) : _react2.default.createElement(
            'div',
            { className: styles.nodata },
            'Hi\u1EC7n t\u1EA1i ch\u01B0a c\xF3 khuy\u1EBFn m\xE3i n\xE0o!'
          )
        ),
        this.renderButton(),
        !!service && _react2.default.createElement(_components.ServiceOptions, {
          key: 'modal_flow_option',
          service: service,
          show: showOption,
          onHide: this.hideOption.bind(this),
          toBooking: this.toBookingWithOption
        }),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_flow',
          show: showFlow,
          onHide: this.hideFlow,
          title: contentFlow.title,
          message: contentFlow.message,
          button: contentFlow.button,
          closeButton: true
        }),
        _react2.default.createElement(_components.ModalCustom, {
          key: 'modal_error',
          show: showErr,
          onHide: this.hideError,
          title: contentErr.title,
          message: contentErr.message,
          button: contentErr.button,
          closeButton: true
        })
      );
    }
  }]);
  return LookmeServiceAtHome;
}(_react.Component), _class2.propTypes = {
  // @data
  // userNo: PropTypes.number,
  user: _react.PropTypes.object,
  history: _react.PropTypes.object,
  configHeader: _react.PropTypes.object,
  SERVICE_OF_HOME_SERVICE: _react.PropTypes.object,
  submit: _react.PropTypes.object,
  shop: _react.PropTypes.object,
  route: _react.PropTypes.object,
  voucherFilters: _react.PropTypes.array,
  voucherFilterChosen: _react.PropTypes.string,
  // dynamicData: PropTypes.object,
  homeOff: _react.PropTypes.bool,
  // @action
  // getAllReward: PropTypes.func,
  // getRewardAtHome: PropTypes.func,
  // getRewardAtSpa: PropTypes.func,
  beforeExchangeReward: _react.PropTypes.func,
  exchangeReward: _react.PropTypes.func,
  changeTab: _react.PropTypes.func,
  setPathName: _react.PropTypes.func,
  setDefaultBooking: _react.PropTypes.func,
  resetBooking: _react.PropTypes.func,
  // getMyReward: PropTypes.func,
  changeShopBeforeBooking: _react.PropTypes.func,
  loadServiceOfHomeService: _react.PropTypes.func,
  changeService: _react.PropTypes.func,
  getShopData: _react.PropTypes.func,
  resetShopDetail: _react.PropTypes.func,
  changeVoucherFilter: _react.PropTypes.func,
  showDownloadAppPopup: _react.PropTypes.func
}, _temp)) || _class);
exports.default = LookmeServiceAtHome;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Reward/LookmeServiceAtHome.js
// module id = 1628
// module chunks = 0